export function isNullOrUndefined(o?: any): boolean {
    if (o === undefined) return true;
    if (o === null) return true;
    return false;
}